import { FormGroup, Input, Label } from "reactstrap";
import { SELLIND_PRODUCT_DATA } from "../../../../Data/Dashboard";

export const SellingProductTableHead = () => {
  return (
    <thead>
      <tr>
        <th>
          <FormGroup check>
            <Input type="checkbox" id="flexCheckDefault" defaultValue="" />
            <Label check htmlFor="flexCheckDefault"></Label>
          </FormGroup>
        </th>
        {SELLIND_PRODUCT_DATA.map((item, index) => (
          <th key={index}>{item}</th>
        ))}
      </tr>
    </thead>
  );
};
